import { render, staticRenderFns } from "./GlobalParms.vue?vue&type=template&id=1b481c8c"
import script from "./GlobalParms.vue?vue&type=script&lang=js"
export * from "./GlobalParms.vue?vue&type=script&lang=js"
import style0 from "./GlobalParms.vue?vue&type=style&index=0&id=1b481c8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports